/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from 'react'
import { Link } from "react-router-dom";
import "./M_main.css"
import Orders from './Orders/Orders';
import Payment from './Payment/Payment';
import Score from './Score/Score';
import { HOST } from './../config';


export default class MainMobileHeader extends Component {
  constructor (props) {
    super(props);
    this.state = {
      PhFSp: [],
      year: "",
      fio: "",
      group: "",
      s_id: "",
      photo: [],
      red: null,
      item: 1,
      dopusk:""
    };

  }

  componentDidMount() {
    setTimeout(() => {
      fetch(`${HOST}/data.json`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: this.props.id_student, gid: this.props.id_group })
      })
        .then((res) => res.json())
        .then((json) => {
          if (json.PhFSp) {
            this.setState({
              PhFSp: json.PhFSp,
              fio: json.PhFSp[0].s_fio,
              group: json.PhFSp[0].groups,
              s_id: json.PhFSp[0].idid
            });
          } else {
            this.setState({
              PhFSp: null,
              fio: null,
              group: null,
              s_id: null
            });
          }
        });
      this.setState({
        photo: JSON.parse(localStorage.getItem('image'))
      });


      fetch(`${HOST}/dopusk.json`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: this.props.id_student,
          idGroup: this.props.id_group,
          idYear: this.props.YEAR,
          idWS: this.props.id_ws,
        }),
      })
        .then((res) => res.json())
        .then((json) => {
          if (json.result === 200)
            this.setState({
              dopusk: json.data ? json.data.dopusk : " - ",
            });
        });

    }
      , 0)
  }

  change = (item) => {
    this.setState({ item })
  }

  render() {

    let PhotoM = [];

    if (this.state.photo && this.state.photo.length > 0) (
      PhotoM.push(
        <img src={`data:image/jpeg;base64,${this.state.photo}`} />
      )
    )
    else {
      PhotoM.push(
        <img src="/lms/public/img/avatar.png" alt="if-empty-name1" />
      )
    }

    return (
      <div>
        <div className="St_containerM">
          <div className="St_Photo">
            {PhotoM}
          </div>
          <div className="St_fio_container">
            <h1>{this.state.fio}</h1>
            <h2 className="St_gr">{this.state.group}</h2>
            <h2 className="St_id">{this.state.s_id}</h2>
            <h2 className="St_id">{this.state.dopusk}</h2>
          </div>
        </div>
        <div className="bottoms_container">
          {this.props.SCORE && <a className="bottom" style={{
            backgroundColor: this.state.item == 1 ? "#FD7E14" : "#fff",
            color: this.state.item == 1 ? "#fff" : "#266BF1",
            borderColor: this.state.item == 1 ? "#FD7E14" : "#266BF1"
          }}
            onClick={() => this.change(1)}>
            Успеваемость
          </a>
          }
          {this.props.ORDERS && <a className="bottom" style={{
            backgroundColor: this.state.item == 2 ? "#FD7E14" : "#fff",
            color: this.state.item == 2 ? "#fff" : "#266BF1",
            borderColor: this.state.item == 2 ? "#FD7E14" : "#266BF1"
          }}
            onClick={() => this.change(2)}>
            Приказы
          </a>
          }
          {this.props.PAYMENT && <a className="bottom" style={{
            backgroundColor: this.state.item == 3 ? "#FD7E14" : "#fff",
            color: this.state.item == 3 ? "#fff" : "#266BF1",
            borderColor: this.state.item == 3 ? "#FD7E14" : "#266BF1"
          }}
            onClick={() => this.change(3)}>
            Оплата
          </a>
          }
        </div>

        <div>
          {this.state.item == 1 && <div>
            <Score SCORE={this.props.SCORE}  YEAR={this.props.YEAR} />
          </div>}
          {this.state.item == 2 && <div>
            <Orders ORDERS={this.props.ORDERS} />
          </div>}
          {this.state.item == 3 && <div>
            <Payment PAYMENT={this.props.PAYMENT} />
          </div>}
        </div>
      </div>
    );
  }
}



